import { createSelector } from 'reselect'

import { DefaultPromptsDictionary } from '@feedyou/schema'

import { botHostingMetadataSelector } from './botHostingMetadataSelector'
import { RootState } from '../../../reducers'

export const defaultPromptsSelector = createSelector(
  (state: RootState) => botHostingMetadataSelector(state)?.buildInfo?.defaultPrompts,

  (defaultPrompts): DefaultPromptsDictionary | undefined => defaultPrompts
)
